'use client';

import React from 'react';

interface IProps {
  text: string | null;
}

const openAxeptioPreferences = () => {
  if (window && window.axeptioSDK) {
    window.openAxeptioCookies();
  } else {
    console.error('Axeptio SDK not loaded');
  }
};

export const FooterCookieButton = ({ text }: IProps) => {
  return (
    <button onClick={() => openAxeptioPreferences()}>
      <div className={'text-sm text-neutral-300'}>{text}</div>
    </button>
  );
};
